import { Box, type BoxProps, Flex, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC } from "react";

interface WithTotalBudgetProps extends BoxProps {
  totalBudget: number | string;
}

const WithTotalBudget: FC<React.PropsWithChildren<WithTotalBudgetProps>> = ({
  totalBudget,
  children,
  ...props
}) => {
  return (
    <Box {...props}>
      {children}
      <Flex align="baseline" justify="end" mx="2" mt="5">
        <Text mr="2" color="grey.500" fontSize="sm" fontWeight="medium">
          <Trans>Total budget</Trans>
        </Text>
        <Text fontSize="xl" fontWeight="semibold">
          {currency.formatByWorkspace(totalBudget)}
        </Text>
      </Flex>
    </Box>
  );
};

export default observer(WithTotalBudget);
